// Mirrors the device: each background frame's time goes to the step detected before it.
// Times in the preds file are cumulative per cycle, so a drop marks the start of a new cycle.
export const getBackgroundAttributionByFrame = (filePreds, backgroundIndex) => {
  const lastFrame = Object.keys(filePreds || {}).reduce(
    (max, key) => (Number(key) > max ? Number(key) : max),
    -1
  );
  if (lastFrame < 0) return [];

  const lookup = [];
  let attributed = {};
  let stepTimes = {};
  let lastStep = null;
  let prevBg = 0;
  for (let f = 0; f <= lastFrame; f++) {
    const { pred, times } = filePreds[f] || {};
    if (pred?.length && pred[0] === backgroundIndex) {
      const current = times?.[0] || 0;
      if (current < prevBg) {
        attributed = {};
        stepTimes = {};
        lastStep = null;
        prevBg = 0;
      }
      const delta = current - prevBg;
      prevBg = current;
      if (lastStep !== null && delta > 0) {
        attributed = {
          ...attributed,
          [lastStep]: (attributed[lastStep] || 0) + delta,
        };
      }
    } else if (pred?.length && pred[pred.length - 1] >= 0) {
      if (pred.some((step, i) => (times?.[i] || 0) < (stepTimes[step] || 0))) {
        attributed = {};
        stepTimes = {};
        prevBg = 0;
      }
      pred.forEach((step, i) => {
        stepTimes[step] = times?.[i] || 0;
      });
      lastStep = pred[pred.length - 1];
    }
    lookup[f] = attributed;
  }
  return lookup;
};

export const addBackgroundToStepsTime = (stepsTime, lookup, frame) => {
  if (!lookup?.length) return stepsTime;
  const attributed = lookup[Math.min(frame, lookup.length - 1)] || {};
  const result = { ...stepsTime };
  Object.entries(attributed).forEach(([step, seconds]) => {
    if (step in result) result[step] += seconds;
  });
  return result;
};
